import classNames from 'classnames'
import React from 'react'

import Session from 'store/session'

import './Account.scss'

const LoginLine = React.memo(function LoginLine({ className, suffix }) {
  const loggedIn = Session.useSelector((store) => !!store.userName)

  if (loggedIn) return null

  const onSignInClick = () => {
    window.location.href = 'https://maxroll.gg/auth/merge'
  }

  return (
    <div className={classNames('d2p-LoginLine', className)}>
      <span onClick={onSignInClick}>{`Sign in`}</span>
      {suffix || ''}
    </div>
  )
})

export const LoginBar = React.memo(function LoginBar() {
  const loggedIn = Session.useSelector((store) => !!store.userName)

  return <div className="d2p-LoginBar">{!loggedIn && <LoginLine />}</div>
})

export default LoginLine
